'use strict';

// validates images in picture tag
function validatePictures() {
    $("picture img").on('error', function () {
        var pictureSources = $(this).siblings("source");
        var placeholderImg = $(this).data('missing-img');
        if (pictureSources && placeholderImg) {
            var pictureDatasrcset = pictureSources.data('srcset'); // for lazyload

            if (pictureDatasrcset) {
                // delete then replace for lazyloading
                pictureSources.removeData("data-srcset");
                pictureSources.attr("data-srcset", placeholderImg);

                $(this).attr('src', placeholderImg);
            }

            pictureSources.prop("srcset", placeholderImg);
        }
    });
}

$(document).ready(function () {
    validatePictures();
});

module.exports = {
    validatePictures: validatePictures
}